<div class="description-list-item">
  <dt class="description-list-item__title">{{ title() }}</dt>

  <dd
    [class.description-list-item__data-as-list]="dataAsList()"
    class="description-list-item__data"
  >
    @if (!dataAsList() && data()) {
      @if (leftIcon()) {
        <app-icon
          [name]="leftIcon()"
          class="description-list-item__data-icon description-list-item__data-icon--left"
        />
      }

      {{ data() }}

      @if (rightIcon()) {
        <app-icon
          [name]="rightIcon()"
          class="description-list-item__data-icon description-list-item__data-icon--right"
        />
      }
    } @else {
      <ng-content />
    }
  </dd>
</div>
